<template>
    <div
        id="lt-yantr"
        class="advanced-calc va-loan-calc">
        <div class="container-width">
            <div class="advanced-calc-filter">
                <ul class="filter-inputs">
                    <li>
                        <drop-down
                            v-model="MortgageLoanType"
                            :label="labelLoanPurpose"
                            :options="MortgageLoanTypeList"
                            @input="calculatePayment()"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model="CreditScore"
                            :label="labelCreditScore"
                            :options="CreditScoreList"
                        />
                        <a
                            href="/redirect/offers?id=calc-fcs"
                            class="font-sm">Get your credit score</a>
                    </li>
                    <li class="zip-code-input">
                        <label>{{ labelPropertyLocation }}</label>
                        <zip-code-input
                            v-model="ZipCode"
                            :autofocus="true"
                            @input="getLocationByZip"
                        />
                        <span
                            v-show="ShowZipCodeError"
                            class="error-msg">Please enter a valid zip code.</span>
                        <div
                            v-show="!ShowZipCodeError"
                            class="address">
                            <span class="lt4-MapPin"></span> {{ Location.city + ', ' + Location.state }}
                        </div>
                    </li>
                    <li>
                        <number-input
                            v-model="HomePrice"
                            :label="labelHomePrice"
                            inputmode="decimal"
                            @input="calculateByHomePrice()"
                        />
                    </li>
                    <li
                        v-show="MortgageLoanType==1"
                        class="inputs-subtext percentage-amt">
                        <number-input
                            v-model="DownPayment"
                            :label="labelDownPayment"
                            :tooltip-link="tooltipDownPayment"
                            maxlength="16"
                            inputmode="decimal"
                            @input="DownPaymentChange($event)"
                        />
                        <span
                            v-show="maxDownpaymentError"
                            class="error-msg">Please enter no more than 16 characters.<br /></span>
                    </li>
                    <li
                        v-show="MortgageLoanType==1"
                        class="percentage-input">
                        <number-input
                            v-model="DownPaymentPercent"
                            symbol="%"
                            symbol-aligned="right"
                            max-value="100.00"
                            inputmode="decimal"
                            precision="2"
                            @input="DownPaymentPercentChange($event)"
                        />
                    </li>
                    <li v-show="MortgageLoanType==2">
                        <number-input
                            v-model="MortgageBalance"
                            :label="labelMortgageBalance"
                            :tooltip-link="tooltipMortgageBalance"
                            @input="calculatePayment()"
                        />
                        <span
                            v-show="maxMortgageBalanceError"
                            class="error-msg">Please enter no more than 16 characters.<br /></span>
                    </li>
                </ul>
                <ul class="filter-inputs">
                    <li>
                        <drop-down
                            v-model="MilitaryExp"
                            :label="labelMilitaryExp"
                            :options="MililitaryExpList"
                            @input="calculatePayment()"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model="HomeType"
                            :label="labelHomeType"
                            :options="HomeTypeList"
                            @input="calculatePayment()"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model="DisabilityStatus"
                            :label="labelDisabilityStatus"
                            :options="DisabilityStatusList"
                            @input="calculatePayment()"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model="FirstTimeVA"
                            :label="labelFirstTimeVA"
                            :options="FirstTimeVAList"
                            @input="calculatePayment()"
                        />
                    </li>
                </ul>
                <!-- Advanced Options start -->
                <div
                    v-show="ShowAdvancedOptions"
                    class="advanced-options"
                    :class="{ 'all-options': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                    <ul class="filter-inputs">
                        <li>
                            <drop-down
                                v-model="LoanTermInYears"
                                :label="labelLoanType"
                                :options="LoanTermInYearsList"
                                @input="calculatePayment()"
                            />
                        </li>
                        <li>
                            <number-input
                                v-model="MortgageRate"
                                :label="labelMortgageRate"
                                symbol="%"
                                symbol-aligned="right"
                                precision="3"
                                max-value="100.000"
                                inputmode="decimal"
                                @input="calculatePayment()"
                            />
                            <a
                                href="/home/va/rates/"
                                target="_blank"
                                class="font-sm">See VA Loan Rates</a>
                        </li>
                        <li class="inputs-subtext">
                            <number-input
                                v-model="HomeInsurance"
                                :label="labelHomeInsurance"
                                inputmode="decimal"
                                @input="calculatePayment()"
                            />
                            <span class="subtext-val">/year</span>
                            <span
                                v-show="maxHomeInsuranceError"
                                class="error-msg">Please enter no more than 16 characters.<br /></span>
                        </li>
                        <li class="inputs-subtext">
                            <number-input
                                v-model="MoHoaFees"
                                :label="labelHOAFees"
                                maxlength="6"
                                inputmode="decimal"
                                @input="calculatePayment()"
                            />
                            <span class="subtext-val">/month</span>
                            <span
                                v-show="maxHoaError"
                                class="error-msg">Please enter no more than 16 characters.<br /></span>
                        </li>
                        <li class="inputs-subtext percentage-amt">
                            <number-input
                                v-model="PropertyTaxes"
                                :label="labelPropertyTaxes"
                                inputmode="decimal"
                                @input="PropertyTaxesChange($event)"
                            />
                            <span class="subtext-val">/year</span>
                        </li>
                        <li class="percentage-input">
                            <number-input
                                v-model="PropertyTaxesPercent"
                                symbol="%"
                                symbol-aligned="right"
                                max-value="100.00"
                                precision="2"
                                inputmode="decimal"
                                @input="PropertyTaxesPercentChange($event)"
                            />
                        </li>
                    </ul>
                </div>
                <a
                    v-show="ShowAdvancedOptions"
                    href="javascript:void(0)"
                    class="reset-calc hidden-xs"
                    @click="resetFilter()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
                <!-- Advanced Options end-->
                <button
                    v-show="ShowAdvancedOptions"
                    class="btn btn-blue recalculate"
                    type="submit"
                    @click="calculateAndViewMore()">
                    {{ recalculateButtonText }}
                </button>
                <label
                    class="show-hide-options"
                    :class="{ 'hidden-xs': ShowAdvancedOptions}"
                    @click="viewMoreClick()">
                    <span
                        class="lt-icons"
                        :class="{ 'lt4-MinusCircle': ShowAdvancedOptions, 'lt4-PlusCircle' : !ShowAdvancedOptions}"></span> {{ !ShowAdvancedOptions ? "" : "Hide" }} Advanced Options
                </label>
            </div>
            <div class="row calculation-section">
                <div
                    v-if="CreditScore > 8"
                    class="low-score-msg">
                    VA loan credit score requirements will vary depending on the lender. A 620 FICO score is a common credit score requirement for a VA loan. See <a href="/home/va/requirements/get-va-home-loan-bad-credit/">how you can get a VA Home Loan with bad credit</a>
                </div>
                <h4
                    v-show="ZipCode!=''&& ShowZipCodeError == false"
                    class="county-title">
                    Your VA Loan Payment in {{ CountyName }} County
                </h4>
                <div class="col-xs-12 col-sm-7 left-section">
                    <h4>Your monthly payment will be:</h4>
                    <label
                        class="homeprice"
                        :class="{ 'red-text': isNegativeAmount(TotalMoPayment)}">${{ currencyWholeNumber(TotalMoPayment) }}</label>
                    <ul class="calc-box three-box">
                        <li>
                            <label>{{ MortgageLoanType == 1 ? "VA Base Loan Amount:" : "Mortgage Amount:" }} </label>
                            <h3
                                v-if="MortgageLoanType == 1"
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(Loanamount)}">
                                ${{ convertCurrency(Loanamount) }}
                            </h3>
                            <h3
                                v-else
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(MortgageBalance)}">
                                ${{ convertCurrency(MortgageBalance) }}
                            </h3>
                        </li>
                        <li>
                            <label>VA Funding Fee: <lt-label
                                :span="span"
                                :tooltip-link="tooltipVaFundingFee"
                            /></label>
                            <h3
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(vaFundingFee)}">
                                ${{ convertCurrency(vaFundingFee) }}
                            </h3>
                        </li>
                        <li>
                            <label>Total Loan Amount:</label>
                            <h3
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(TotalLoanAmount)}">
                                ${{ convertCurrency(TotalLoanAmount) }}
                            </h3>
                        </li>
                    </ul>
                    <div class="view-free-offers">
                        <h4>We’ve found offers for this result:</h4>
                        <button
                            class="btn btn-blue"
                            type="submit"
                            @click="redirect()">
                            {{ DestinationButtonText }}
                        </button>
                    </div>
                    <div>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="DisclosureText"
                            :disclosure-tokens="DisclosureTokens"
                        />
                    </div>
                    <lt-logo v-if="ltLogo==1">
                        <small>NMLS#1136 Terms & Conditions Apply</small>
                    </lt-logo>
                </div>
                <div class="col-xs-12 col-sm-5 right-section text-center">
                    <h4>Monthly Payment Breakdown</h4>
                    <div class="chart-parent">
                        <vue-chart
                            id="donutChart"
                            type="doughnut"
                            :data="chartData"
                            :options="options"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                        <div class="donut-inner">
                            <label>Total Monthly Payment:</label>
                            <h3 :class="{ 'red-text': isNegativeAmount(TotalMoPayment)}">
                                ${{ convertCurrency(TotalMoPayment) }}
                            </h3>
                        </div>
                    </div>
                    <div class="monthly-budget">
                        <ul class="list-unstyled summary">
                            <li>
                                <label><span class="green-bg"></span> Principal & Interest:</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoPrincipalIntestrest)}">${{ convertCurrency(MoPrincipalIntestrest) }}</span>
                            </li>
                            <li>
                                <label><span class="red-bg"></span> Property Taxes:</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoPropertyTaxes)}">${{ convertCurrency(MoPropertyTaxes) }}</span>
                            </li>
                            <li>
                                <label><span class="blue-bg"></span> Homeowners Insurance:</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoHomeInsurance)}">${{ convertCurrency(MoHomeInsurance) }}</span>
                            </li>
                            <li>
                                <label><span class="purple-bg"></span> HOA Dues:</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoHoaFees)}">${{ convertCurrency(MoHoaFees) }}</span>
                            </li>
                        </ul>
                        <div class="clear-fix"></div>
                    </div>
                </div>
            </div>
            <div class="full-width-border"></div>
        </div>
    </div>
</template>

<script>
    import VueChart from 'vue-chart-js';
    import Accounting from 'accounting';
    import VueScrollTo from 'vue-scrollto';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import CreditScoreList from '~/constants/credit-score-list';
    import HomeTypeList from '~/constants/home-type-list';
    import LoanTermList from '~/constants/loan-term-list';
    import LoanTypeList from '~/constants/loan-type-list';
    import VaTypeLoanList from '~/constants/va-loan-list';
    import LtLabel from '~/components/lt-label.vue';
    import ChartTooltip from '~/helpers/chart-tooltip';
    import BaseMixin from '~/mixin/base-mixin';
    import LtLogo from '~/components/lt-logo.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import StringFormat from '~/helpers/string-format';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import GraphQLMixin from '~/mixin/graphql';
    import LimitsFromZipByCode from '~/services/graphql/LimitsFromZipByCode.gql';
    import { getFinancialApiUrl, setHeader } from '~/helpers/financialapi-url-env';

    export default {
        components: {
            NumberInput,
            DropDown,
            LtLabel,
            VueChart,
            LtLogo,
            AdvertisingDisclosures,
            ZipCodeInput,
        },
        directives: {
            VueScrollTo,
        },
        mixins: [BaseMixin, GraphQLMixin],
        props: {
            graphQlUri: {
                default: '',
            },
            labelLoanPurpose: {
                default: 'Loan Purpose:',
            },
            labelHomePrice: {
                default: 'Home Price:',
            },
            labelDownPayment: {
                default: 'Down Payment:',
            },
            labelCreditScore: {
                default: 'Credit Score:',
            },
            labelMilitaryExp: {
                default: 'Military Experience:',
            },
            labelCountyName: {
                default: 'County Name:',
            },
            labelLoanType: {
                default: 'Loan Type:',
            },
            labelMortgageRate: {
                default: 'Mortgage Rate:',
            },
            labelPropertyTaxes: {
                default: 'Property Taxes:',
            },
            labelHomeInsurance: {
                default: 'Homeowners Insurance:',
            },
            labelHOAFees: {
                default: 'HOA Fees:',
            },
            labelHomeType: {
                default: 'Home Type:',
            },
            labelDisabilityStatus: {
                default: 'Disability Status:',
            },
            labelFirstTimeVA: {
                default: 'First-time VA Loan:',
            },
            mortgageLoanType: {
                default: 1,
            },
            homePrice: {
                default: 250000,
            },
            downPayment: {
                default: 0,
            },
            creditScore: {
                default: 2,
            },
            militaryExp: {
                default: 'Regular',
            },
            countyName: {
                default: 'Mecklenburg',
            },
            loanTermInYears: {
                default: 30,
            },
            mortgageRate: {
                default: 3.750,
            },
            propertyTaxes: {
                default: 0,
            },
            homeInsurance: {
                default: 800,
            },
            hoaFees: {
                default: 0,
            },
            disabilityStatus: {
                default: 'Notdisabled',
            },
            firstTimeVA: {
                default: 'First',
            },
            homeType: {
                default: 1,
            },
            tooltipDownPayment: {
                default: 'down-payment',
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            howToUseCalculator: {
                default: 1,
            },
            labelPropertyLocation: {
                default: 'Property Location:',
            },
            geoLocation: {
                type: Object,
                default() {
                    return {
                        zipCode: '',
                        city: '',
                        state: '',
                    };
                },
            },
            showAdvancedOptions: {
                default: false,
            },
            customizeButtonText: {
                default: 'Customize',
            },
            recalculateButtonText: {
                default: 'Recalculate',
            },
            totalMoPayment: {
                default: 2414,
            },
            tooltipVaFundingFee: {
                default: 'va-funding-fee',
            },
            destinationLinkOrId: {
                default: 'ns-calc-va',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            moPrincipalIntestrest: {
                default: 1897,
            },
            moPropertyTaxes: {
                default: 425,
            },
            moHomeInsurance: {
                default: 67,
            },
            moHoaFees: {
                default: 100,
            },
            moVAFundingFee: {
                default: 25,
            },
            labelMortgageBalance: {
                default: 'Mortgage balance:',
            },
            tooltipMortgageBalance: {
                default: 'mortgage',
            },
            mortgageBalance: {
                default: 200000,
            },
            downpaymentPercent: {
                default: 0.00,
            },
            propertyTaxesPercent: {
                default: 1.20,
            },
            maxValue: {
                default: 999999999,
            },
            userZip: {
                default: '35406',
            },
            disableZipcodeGeo: {
                default: 'false',
            },
        },
        data() {
            return {
                GraphQlUri: this.graphQlUri,
                ZipCode: '',
                ShowZipCodeError: false,
                Location: this.geoLocation,
                HomePrice: this.homePrice,
                DownPayment: this.downPayment,
                CreditScore: this.creditScore,
                MilitaryExp: this.militaryExp,
                CountyName: this.countyName,
                MortgageLoanType: this.mortgageLoanType,
                MortgageRate: this.mortgageRate,
                PropertyTaxes: this.propertyTaxes,
                HomeInsurance: this.homeInsurance,
                HOAFees: this.hoaFees,
                DisabilityStatus: this.disabilityStatus,
                FirstTimeVA: this.firstTimeVA,
                HomeType: this.homeType,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowAdvancedOptions: this.showAdvancedOptions,
                CustomizeButtonText: this.customizeButtonText,
                RecalculateButtonText: this.recalculateButtonText,
                TotalMoPayment: this.totalMoPayment,
                CreditScoreList: CreditScoreList.homeaffordability,
                HomeTypeList,
                LoanTermInYears: this.loanTermInYears,
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.va,
                MortgageLoanTypeList: LoanTypeList.MortgageLoanTypeList,
                MililitaryExpList: VaTypeLoanList.VaLoanList.mililitaryexp,
                DisabilityStatusList: VaTypeLoanList.VaLoanList.disabilitystatus,
                FirstTimeVAList: VaTypeLoanList.VaLoanList.firsttimeva,
                MoPrincipalIntestrest: this.moPrincipalIntestrest,
                MoPropertyTaxes: this.moPropertyTaxes,
                MoHomeInsurance: this.moHomeInsurance,
                MoHoaFees: this.moHoaFees,
                MoVAFundingFee: this.moVAFundingFee,
                span: '',
                HomeValue: this.homePrice,
                MortgageBalance: this.mortgageBalance,
                isHomePurchase: true,
                StateCode: 'NC',
                LoanLimit: 417000,
                HomePriceLimit: 0,
                MaxDownPayment: 0,
                HomePriceAsNumber: this.homeprice,
                DownPaymentAsNumber: this.downPayment,
                Loanamount: 0,
                TotalLoanAmount: 0,
                DefaultLoanLimit: 417000,
                vaFundingFee: 0,
                maxDownpaymentError: false,
                maxHoaError: false,
                maxHomeInsuranceError: false,
                maxMortgageBalanceError: false,
                // Setting for chart
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            backgroundColor: [
                                '#08c177',
                                '#da3551',
                                '#00aeef',
                                '#2087c1',
                                '#ff704d',
                            ],
                            borderWidth: 0,
                        },
                    ],
                },
                options: {
                    cutoutPercentage: 89,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                        custom: ChartTooltip.customTooltips,
                    },
                },
                chartWidth: 200,
                chartHeight: 130,
                CurrentDate: new Date(),
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                DownPaymentPercent: Accounting.formatNumber(this.downpaymentPercent, { precision: 2 }),
                PropertyTaxesPercent: this.propertyTaxesPercent,
            };
        },
        watch: {
            getFieldValue() {
                this.calculatePayment();
            },
            async ZipCode(zip) {
                if (zip.length > 4) {
                    await this.getCounty(zip);
                }
            },
        },
        mounted() {
            this.GraphQlUri = this.graphQlUri !== '' ? this.graphQlUri : getFinancialApiUrl();
            this.createGraphQlClient(this.GraphQlUri, setHeader);
            let zip = '';
            if (this.disableZipcodeGeo === 'true') zip = '28277';
            else if (this.disableZipcodeGeo === 'false') {
                zip = '28277';
                this.ZipCode = '28277';
            }
            this.getCounty(zip);
            this.calculateByHomePrice();
            this.getLocationByZip(this.ZipCode);
            this.ShowZipCodeError = this.ZipCode === '' && this.disableZipcodeGeo === 'true' ? false : this.ShowZipCodeError;
            this.chartData.datasets[0].data.push(this.MoPrincipalIntestrest);
            this.chartData.datasets[0].data.push(this.MoPropertyTaxes);
            this.chartData.datasets[0].data.push(this.MoHomeInsurance);
            this.chartData.datasets[0].data.push(100);
            this.chartData.labels.push(`Principal & Interest ${Accounting.formatMoney(this.MoPrincipalIntestrest)}`);
            this.chartData.labels.push(`Property Taxes ${Accounting.formatMoney(this.MoPropertyTaxes)}`);
            this.chartData.labels.push(`Homeowners Insurance ${Accounting.formatMoney(this.MoHomeInsurance)}`);
            this.chartData.labels.push(`HOA Dues ${Accounting.formatMoney(this.MoHoaFees)}`);
        },
        methods: {
            calculateAndViewMore() {
                this.viewMoreClick();
            },
            currencyFilterWithPrecision(figure) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision: 2 }) : 0;
            },
            currencyWholeNumber(figure) {
                return figure > 0 ? Accounting.formatNumber(figure) : 0;
            },
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.isZipCodeValidFormat(zip)) {
                    GetLocation.methods.GetZipCode(zip, this.setLocationData);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            isZipCodeValidFormat(zip) {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(zip) && zip !== '';
            },
            setLocationData(geoData) {
                const isError = 'err' in geoData && geoData.err === true;
                if (isError) {
                    this.ShowZipCodeError = true;
                } else {
                    this.ShowZipCodeError = false;
                    const cityNameFormatted = StringFormat.capitalize(geoData.city);
                    geoData.city = cityNameFormatted;
                    this.Location = geoData;
                    this.StateCode = geoData.state;
                    this.getCounty(this.ZipCode);
                }
            },
            async getCounty(zip) {
                const variables = {
                    zip,
                    soaCode: 'GSE',
                    titleCase: true,
                };

                try {
                    const data = await this.graphQlQuery(LimitsFromZipByCode, variables);
                    const { limits } = data;
                    if (limits !== undefined) {
                        if (limits.limit1LivingUnit) {
                            this.updateLoanLimit(limits.limit1LivingUnit);
                        }
                        if (limits.countyName) {
                            this.CountyName = limits.countyName;
                        }
                    }
                } catch (e) {
                    console.warn(`Error getting county from zip code: ${e}`);
                }
            },

            viewMoreClick() {
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },
            updateLoanLimit(limit) {
                this.LoanLimit = limit;
                this.MaxDownPayment = this.LoanLimit;
                this.HomePriceLimit = Math.round(this.LoanLimit * 0.9825 / 0.965);
            },
            calculatePayment() {
                const homeInsuranceVal = Accounting.unformat(this.HomeInsurance);
                const homeprice = this.HomePriceAsNumber;
                const downpayment = this.DownPaymentAsNumber;
                const rate = this.MortgageRate / 1200;
                const loanterm = this.LoanTermInYears * 12;
                let hoi = this.HomePriceAsNumber > 0 ? homeInsuranceVal / 12 : 0;
                const proptaxrate = this.PropertyTaxesPercent / 1200;
                const downpaymentPercentCal = Math.round(downpayment / homeprice * 100);
                const loanamount = homeprice - downpayment;
                let proptax = homeprice * proptaxrate;
                let tier = 'tier1';
                if (downpaymentPercentCal < 5) tier = 'tier1';
                else if (downpaymentPercentCal > 5 && downpaymentPercentCal < 10) tier = 'tier2';
                else if (downpaymentPercentCal > 10) tier = 'tier3';
                const totalText = this.DisabilityStatus + this.FirstTimeVA + this.MilitaryExp + tier;
                const veteranfeejson = VaTypeLoanList.VeteranFeeList;
                const veteranValue = homeprice;
                let veteranFee = veteranfeejson[totalText];
                let vaFundingfee = veteranFee / 100 * veteranValue;
                vaFundingfee = !isNaN(vaFundingfee) ? vaFundingfee : 0;
                let pmi = vaFundingfee / 360;
                this.TotalLoanAmount = this.MortgageLoanType === 1 ? vaFundingfee + loanamount : vaFundingfee + Accounting.unformat(this.MortgageBalance);
                let pi = this.TotalLoanAmount * (rate * (1 + rate) ** loanterm / ((1 + rate) ** loanterm - 1));
                if (Accounting.unformat(this.MortgageLoanType) === 2) {
                    // Caclulations for VA refinanceing
                    hoi = this.HomeValue > 0 ? homeInsuranceVal / 12 : 0;
                    pi = Accounting.unformat(this.MortgageBalance) * (rate * (1 + rate) ** loanterm / ((1 + rate) ** loanterm - 1));
                    proptax = parseFloat(this.HomeValue) * proptaxrate;
                }
                // Display the final values in UI
                this.MoPrincipalIntestrest = !isNaN(pi) ? Math.round(pi) : 0;
                this.MoPropertyTaxes = proptax;
                this.MoHomeInsurance = Math.round(hoi);
                this.MoVAFundingFee = Math.round(pmi);

                this.vaFundingFee = vaFundingfee;
                this.Loanamount = loanamount;
                this.chartData.datasets[0].data = [];
                this.chartData.labels = [];
                this.TotalMoPayment = parseFloat(this.MoPrincipalIntestrest) + parseFloat(this.MoPropertyTaxes) + parseFloat(this.MoHomeInsurance) + parseFloat(this.MoHoaFees);
                this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoPrincipalIntestrest, this.TotalMoPayment));
                this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoPropertyTaxes, this.TotalMoPayment));
                this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoHomeInsurance, this.TotalMoPayment));
                this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoHoaFees, this.TotalMoPayment));
                this.chartData.labels.push(`Principal & Interest ${Accounting.formatMoney(this.MoPrincipalIntestrest, { precision: 0 })}`);
                this.chartData.labels.push(`Property Taxes ${Accounting.formatMoney(this.MoPropertyTaxes, { precision: 0 })}`);
                this.chartData.labels.push(`Homeowners Insurance ${Accounting.formatMoney(this.MoHomeInsurance, { precision: 0 })}`);
                this.chartData.labels.push(`HOA Dues ${Accounting.formatMoney(this.MoHoaFees, { precision: 0 })}`);
                this.maxHoaError = this.MoHoaFees.toString().length >= 16;
                this.maxHomeInsuranceError = homeInsuranceVal.toString().length >= 16;
                this.maxMortgageBalanceError = this.MortgageBalance.toString().length >= 16;
            },
            calculatePercentage(value, divider) {
                return Math.round(value / divider * 100);
            },
            convertCurrency(figure) {
                return Accounting.formatNumber(Math.abs(this.unformat(figure)));
            },
            calculateByHomePrice() {
                this.HomePriceAsNumber = Accounting.unformat(this.HomePrice);
                if (this.HomePriceLimit > 0 && Accounting.unformat(this.HomePrice) > this.HomePriceLimit) {
                    this.HomePrice = Accounting.formatNumber(this.HomePriceLimit);
                    this.HomePriceAsNumber = this.HomePriceLimit;
                }
                this.InitializeData();
                this.calculatePayment();
            },
            calculateByDownPayment() {
                this.maxDownpaymentError = this.DownPayment.toString().length >= 16;
                this.DownPaymentAsNumber = this.unformat(this.DownPayment);
                this.calculatePayment();
            },
            isNegativeAmount(figure) {
                return figure < 0;
            },
            resetFilter() {
                this.PropertyTaxesPercent = Accounting.formatNumber(this.propertyTaxesPercent, { precision: 2 });
                this.PropertyTaxes = parseFloat(this.getDollarAmount(this.PropertyTaxesPercent));
                let zip = '';
                if (this.disableZipcodeGeo === 'true') {
                    this.ZipCode = '';
                    zip = '28277';
                } else if (this.disableZipcodeGeo === 'false') {
                    zip = '28277';
                    this.ZipCode = '28277';
                }
                this.getCounty(zip);
                this.DownPayment = Accounting.formatNumber(this.downPayment);
                this.DownPaymentAsNumber = this.downPayment;
                this.DownPaymentPercent = Accounting.formatNumber(this.downPaymentPercent, { precision: 2 });
                this.calculateByHomePrice();
                this.getLocationByZip(this.ZipCode);
                this.LoanTermInYears = this.loanTermInYears;
                this.MortgageRate = Accounting.formatNumber(this.mortgageRate, { precision: 3 });
                this.HomeInsurance = this.homeInsurance;
                this.HOAFees = this.hoaFees;
                this.HomePriceAsNumber = this.homePrice;
                this.HomePrice = Accounting.formatNumber(this.homePrice);
                this.HomeValue = this.homePrice;
                this.MortgageBalance = Accounting.formatNumber(this.mortgageBalance);
                this.CreditScore = this.creditScore;
                this.MilitaryExp = this.militaryExp;
                this.HomeType = this.homeType;
                this.DisabilityStatus = this.disabilityStatus;
                this.FirstTimeVA = this.firstTimeVA;
                this.MortgageLoanType = this.mortgageLoanType;
                this.calculatePayment();
                this.ShowZipCodeError = this.ZipCode === '' && this.disableZipcodeGeo === 'true' ? false : this.ShowZipCodeError;
            },
            DownPaymentChange(value) {
                let downPaymentValue = this.unformat(value);
                if (downPaymentValue > this.unformat(this.HomePrice)) {
                    downPaymentValue = this.HomePrice;
                    this.DownPayment = Accounting.formatNumber(downPaymentValue);
                } else if (downPaymentValue > this.unformat(this.maxValue)) {
                    this.DownPayment = this.unformat(this.maxValue);
                    downPaymentValue = this.unformat(this.maxValue);
                }
                this.calculateByDownPayment();
                this.DownPaymentPercent = this.getPercentageAmount(downPaymentValue);
            },
            DownPaymentPercentChange(value) {
                this.DownPayment = 0;
                this.$nextTick(() => {
                    this.DownPayment = Accounting.formatNumber(this.getDollarAmount(value));
                    if (this.unformat(this.DownPayment) > this.unformat(this.HomePrice)) {
                        this.DownPayment = Accounting.formatNumber(this.HomePrice);
                    }
                    this.calculateByDownPayment();
                });
            },
            PropertyTaxesChange(value) {
                let propertyTaxesValue = this.unformat(value);
                if (propertyTaxesValue > this.unformat(this.HomePrice)) {
                    propertyTaxesValue = this.HomePrice;
                    this.PropertyTaxes = propertyTaxesValue;
                } else if (propertyTaxesValue > this.unformat(this.maxValue)) {
                    this.PropertyTaxes = this.maxValue;
                    propertyTaxesValue = this.maxValue;
                }
                this.PropertyTaxesPercent = this.getPercentageAmount(propertyTaxesValue);
                this.calculatePayment();
            },
            PropertyTaxesPercentChange(value) {
                this.PropertyTaxes = 0;
                this.$nextTick(() => {
                    this.PropertyTaxes = Accounting.formatNumber(parseFloat(this.getDollarAmount(value)));
                    if (this.unformat(this.HomePrice) > 0 && this.unformat(this.PropertyTaxes) > this.unformat(this.HomePrice)) {
                        this.PropertyTaxes = this.unformat(this.HomePrice);
                    }
                    this.calculatePayment();
                });
            },
            getDollarAmount(value) {
                const calculatedValue = this.unformat(value) / 100 * this.unformat(this.HomePrice);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : Math.round(calculatedValue);
            },
            getPercentageAmount(value) {
                let calculatedValue = this.unformat(value) / this.unformat(this.HomePrice) * 100;
                calculatedValue = calculatedValue.toFixed(2);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : calculatedValue;
            },
            InitializeData() {
                this.DownPaymentPercentChange(this.DownPaymentPercent);
                this.PropertyTaxesPercentChange(this.PropertyTaxesPercent);
            },
            unformat(val) {
                return Accounting.unformat(val);
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
